import moment from 'moment';

export const isPerformanceAdmin = auth => Boolean(
    auth && auth.auth && auth.userInfo && auth.userInfo.username === 'admin@example.com'
);

export const todayHkt = () => moment.utc().utcOffset(480).format('YYYY-MM-DD');

export function dashboardDates(start, end) {
    const first = moment.utc(start, 'YYYY-MM-DD', true);
    const last = moment.utc(end, 'YYYY-MM-DD', true);
    if (!first.isValid() || !last.isValid() || first.isBefore('2000-01-01')
        || last.isBefore(first) || last.diff(first, 'days') >= 31 || end > todayHkt()) {
        return [];
    }
    const dates = [];
    for (let day = first.clone(); !day.isAfter(last); day.add(1, 'day')) {
        dates.push(day.format('YYYY-MM-DD'));
    }
    return dates;
}

export function eventCounts(events, dates, groups, groupFor) {
    const buckets = new Map(dates.map(day => [day, new Map()]));
    events.forEach(event => {
        const bucket = buckets.get(event.day_hkt);
        if (bucket) {
            const group = groupFor(event);
            bucket.set(group, (bucket.get(group) || 0) + 1);
        }
    });
    return dates.map(day => ({
        label: day,
        values: groups.map(group => buckets.get(day).get(group) || 0),
    }));
}

export function screenTimings(events, dates) {
    return dates.map(day => {
        const values = events.filter(event => event.day_hkt === day
            && event.event_type === 'operation' && event.operation_name === 'auction_groups.list'
            && event.outcome === 'success' && Number.isFinite(event.client_duration_ms))
            .map(event => event.client_duration_ms / 1000).sort((a, b) => a - b);
        return {
            label: `${day} (n=${values.length})`,
            values: values.length
                ? [values[Math.ceil(values.length / 2) - 1], values[values.length - 1]]
                : [null, null],
        };
    });
}

export function summaryTimings(events) {
    const requests = events.filter(event => event.event_type === 'request'
        && event.route_template === '/auction_group_summaries');
    const measured = requests.filter(event =>
        [event.client_duration_ms, event.server_total_ms, event.db_ms].every(Number.isFinite)
        && event.db_ms >= 0 && event.server_total_ms >= event.db_ms
        && event.client_duration_ms >= event.server_total_ms
    ).sort((a, b) => b.client_duration_ms - a.client_duration_ms);
    return {
        total: requests.length,
        measured: measured.length,
        data: measured.slice(0, 20).map((event, index) => ({
            label: `${index + 1}. ${event.received_at_hkt.replace('T', ' ')} · ${event.supplier_name}`,
            values: [
                event.db_ms / 1000,
                (event.server_total_ms - event.db_ms) / 1000,
                (event.client_duration_ms - event.server_total_ms) / 1000,
            ],
        })),
    };
}
